import { useEffect, useRef } from "react";
import InputTextLine from "components/atoms/input/TextLine";

interface Props {
  placeholder?: string;
  className?: string;
  onChageEachMeasure: (squareMeasure: string) => void;
  squareMeasure?: string;
  focus?: boolean;
}

// 팔레트 - 면적 입력
const SquareMeasure = ({
  placeholder,
  className,
  onChageEachMeasure,
  squareMeasure,
  focus,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (focus) {
      inputRef.current?.focus();
    }
  }, [focus]);

  return (
    <InputTextLine
      ref={inputRef}
      value={squareMeasure}
      onChange={({ target }) => onChageEachMeasure(target.value)}
      placeholder={placeholder}
      className={`${className} ${focus && "!border-red"}`}
    />
  );
};

export default SquareMeasure;
